export default "__VITE_ASSET__0b1640a5__"